import { render, staticRenderFns } from "./fixGrid.vue?vue&type=template&id=0155e512&scoped=true&"
import script from "./fixGrid.vue?vue&type=script&lang=js&"
export * from "./fixGrid.vue?vue&type=script&lang=js&"
import style0 from "./fixGrid.vue?vue&type=style&index=0&id=0155e512&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0155e512",
  null
  
)

export default component.exports